import { useState } from "react";

import { Drawer, DrawerContent } from "common/components/ui/Drawer";

import DeleteLabel from "./DeleteLabel";
import LabelForm from "./LabelForm";

import type { Label, LabelType } from "../../types";

interface LabelDrawerProps {
  label?: Label;
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  labelType: LabelType;
}
export default function LabelDrawer({
  label = null,
  isOpen,
  setIsOpen,
  labelType,
}: LabelDrawerProps) {
  const [isDeleting, setIsDeleting] = useState(false);

  return (
    <Drawer
      open={isOpen}
      onOpenChange={setIsOpen}
      onAfterClose={() => setIsDeleting(false)}
    >
      <DrawerContent>
        {isDeleting ? (
          <DeleteLabel
            labelId={label.id}
            onBack={() => setIsDeleting(false)}
            labelType={labelType}
          />
        ) : (
          <LabelForm
            label={label}
            type={labelType}
            onBack={() => setIsOpen(false)}
            onDelete={() => setIsDeleting(true)}
          />
        )}
      </DrawerContent>
    </Drawer>
  );
}
